function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== "undefined" &&
    right[Symbol.hasInstance]
  ) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function showCartLoaders() {
  document.querySelector("[data-animated-cart-loader]").classList.add("show");
  document.querySelector("[data-cart-loading-spinner]").classList.add("show");
}

function hideCartLoaders() {
  document.querySelector("[data-animated-cart-loader]").classList.remove("show");
  document.querySelector("[data-cart-loading-spinner]").classList.remove("show");
}

var CartDrawer = /*#__PURE__*/ (function () {
  "use strict";

  function CartDrawer(
    cartDrawer,
    itemTemplate,
    gridView,
    listView,
    listButton,
    gridButton
  ) {
    _classCallCheck(this, CartDrawer);

    this.SELLING_PLAN_ID = "3040903353";

    this.drawer = document.querySelector(cartDrawer);
    this.item = document.querySelector(itemTemplate);
    this.grid = document.querySelector(gridView);
    this.list = document.querySelector(listView);
    this.listButton = document.querySelector(listButton);
    this.gridButton = document.querySelector(gridButton);
    this.awaitingAsyncAction = false; 
    this.isMonthlySubscriptionActive = false;
  }

  _createClass(CartDrawer, [
    {
      key: "showCartLoaders",
      value: showCartLoaders,
    },
    {
      key: "hideCartLoaders",
      value: hideCartLoaders,
    },
    {
      key: "checkDrawer",
      value: function checkDrawer() {
        if (this.drawer.classList.contains("active")) {
          return true;
        } else {
          return false;
        }
      },
    },
    {
      key: "checkGrid",
      value: function checkGrid() {
        if (this.grid && this.grid.classList.contains("hide")) {
          return false;
        } else {
          return true;
        }
      },
    },
    {
      key: "checkList",
      value: function checkList() {
        if (this.list.classList.contains("hide")) {
          return false;
        } else {
          return true;
        }
      },
    },
    {
      key: "setMonthlySubscriptionState",
      value: async function setMonthlySubscriptionState() {
        if (await allItemsAreMonthly()) {
          this.isMonthlySubscriptionActive = true;
        } else {
          this.isMonthlySubscriptionActive = false;
        }
      },
    },
    {
      key: "openDrawer",
      value: function openDrawer() {
        // enable or disable overlay about empty cart
        //this.changeDrawerStatus();
        this.checkHeaderHeight();
        this.drawer.classList.add("active");
        document.body.classList.add("cart-drawer-active");

        //move cart grid to left on cartdrawer open
        if (
          $(".collection_grid_wrapper").hasClass(
            "collection_grid_move_on_cart_open"
          )
        ) {
          var cart_grid_offset_left = document.querySelector(
            ".collection_grid_wrapper"
          ).offsetLeft;
          $(".collection_grid_wrapper > .grid").css(
            "transform",
            "translateX(-" + cart_grid_offset_left + "px)"
          );
        }
      },
    },
    {
      key: "openList",
      value: function openList() {
        // open the list layout
        if (!this.checkList()) {
          this.list.classList.remove("hide");
          this.grid.classList.add("hide");
          this.list.parentElement.classList.remove("stretch-bg");
          this.closeDrawer();
        }
      },
    },
    {
      key: "openGrid",
      value: function openGrid() {
        // open the grid layout
        if (!this.checkGrid()) {
          this.grid.classList.remove("hide");
          this.list.classList.add("hide");
          this.list.parentElement.classList.add("stretch-bg");
          if (window.innerWidth > 1160) {
            //this.openDrawer();
          }
        }
      },
    },
    {
      key: "closeDrawer",
      value: function closeDrawer() {
        this.drawer.classList.remove("active");
        document.body.classList.remove("cart-drawer-active");
        if (
          $(".collection_grid_wrapper").hasClass(
            "collection_grid_move_on_cart_open"
          )
        ) {
          $(".collection_grid_wrapper > .grid").css(
            "transform",
            "translateX(0)"
          );

          $(".collection_grid_wrapper > .grid").css("transform", "unset");
        }

        if (window.location.hash == "#cart") {
          //window.location.hash = '';
          var url_without_hash = window.location.href.substr(
            0,
            window.location.href.indexOf("#")
          );
          history.pushState("data", "", url_without_hash);
        }
      },
    },
    {
      key: "changeDrawerStatus",
      value: function changeDrawerStatus() {
        var emptyCartOverlay = document.querySelector("#empty-cart-drawer"),
          clearCart = document.querySelector("#clear-cart-items"),
          cartDrawerItemsCount =
            this.drawer.querySelectorAll(".item__wrapper").length;
 
        if (cartDrawerItemsCount > 0) {
          emptyCartOverlay.classList.remove("active");
          clearCart.classList.add("active");
          document.getElementById("collection__goto_checkout")?.classList.remove("d-none");
        } else {
          emptyCartOverlay.classList.add("active");
          clearCart.classList.remove("active");
          if (!document.getElementById("collection__goto_checkout")?.classList.contains("d-none")) {
            document.getElementById("collection__goto_checkout")?.classList.add("d-none");
          }
        }
      },
    },
    {
      key: "checkHeaderHeight",
      value: function checkHeaderHeight() {
        var header = document.querySelector("#shopify-section-header"),
          headerHeight = header.offsetHeight;
        this.drawer.querySelector("#cart-drawer__cart").style.height =
          "calc(100% - ".concat(headerHeight - 1, "px)");
      },
    },
    {
      key: "addToDrawer",
      value: 
      // function addToDrawer(item) {
      //   // console.log("addToDrawer: ", item);

      //   var itemInput = document.querySelectorAll(
      //     'input.quantity-detector[data-id="'.concat(item.productId, '"]')
      //   );
      //   var itemsPlace = this.drawer.querySelector(".cart-drawer__cart-items"),
      //     newItem = this.renderTemplateData(this.item.innerHTML, item),
      //     itemInCart = this.drawer.querySelector(
      //       '.item__wrapper[data-id="'.concat(item.productId, '"]')
      //     ); // check for empty value
      //   if (item.productCount.length == 0) {
      //     item.productCount = null;
      //   } // checking for existing current item in the cart

      //   var isInputFieldInactiveAndZero = function (input) {
      //     return (
      //       input !== document.activeElement &&
      //       (input.value === "" || input.value <= 0)
      //     );
      //   };

      //   for (var i = 0; i < itemInput.length; i++) {
      //     itemInput[i].addEventListener(
      //       "blur",
      //       function (event) {
      //         if (isInputFieldInactiveAndZero(event.target)) {
                
                
      //           this.removeFromDrawer(item);
                
      //           // You may need to use a reference to "this" depending on your context.
      //         }
      //       }.bind(this)
      //     );
      //   }

      //   if (typeof itemInCart != "undefined" && itemInCart != null) {
      //     // if an item in the cart - checking quantity. If 0 - removing item else update item count and price
      //     if (item.productCount >= 0) {

      //       // this will only fire when the action is 'update' or when the user types in the input field
      //       // see input event listeners below
      //       if (item.action == "update") {
      //         let currentProductQuantity = parseInt(itemInCart.querySelector(".item__image-count").innerText);
      //         if (isNaN(currentProductQuantity)) currentProductQuantity = 0;
      //         let newProductQuantity = parseInt(item.productCount);
              
      //         if (currentProductQuantity > newProductQuantity) {
      //           this.removeImageAnimation(item.productImage);
      //         } else if (currentProductQuantity < newProductQuantity) {
      //           this.addImageAnimation(item.productImage);
      //         }
      //       }

      //       this.updateItemPrice(item);
      //       this.updateItemDrawerQty(item);

      //       if (item.productCount == 0) {
      //         this.removeFromDrawer(item);
      //       }

      //       if (item.action == "add") {
      //         this.addImageAnimation(item.productImage);
      //       } else if (item.action == "remove") {
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     } else {
      //       if (item.type !== "modal" || isInputFieldInactiveAndZero()) {
              
                
      //         this.removeFromDrawer(item);
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     }

      //     // maybe move this above to be the first one in the conditional in order to make 
      //     // sure this is executed no matter what action fails to be executed within the custom cart drawer
      //     this.changeCartItem(
      //       item.productId,
      //       item.productCount,
      //       "change",
      //       item.ajaxQuery
      //     );
      //   } else if (item.productCount > 0) {
      //     // add animation for a product image
      //     if (item.itemAnimation) {
      //       if (item.action == "add") {
      //         this.addImageAnimation(item.productImage);
      //       } else if (item.action == "remove") {
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     }
      //     // if an item is in the cart - rendering item and pushing to the cart

      //     itemsPlace.insertAdjacentHTML("afterbegin", newItem);
      //     this.changeCartItem(
      //       item.productId,
      //       item.productCount,
      //       "add",
      //       item.ajaxQuery
      //     );
      //     initCartEvent(item);
      //   } // set a qty value

      //   this.updateSubtotalAndCartNumber();

      //   this.setInputValue(item); // opening drawer if not opened and not mobile version

      //   var addedItem = {
      //     productId: item.productId,
      //     productTitle: item.productTitle,
      //     productCategory: item.productCategory,
      //     productImage: item.productImage,
      //     productPrice: item.productPrice,
      //   };
      //   // _learnq.push(['track', 'Added to Cart', addedItem]);

      //   if (
      //     window.innerWidth > 1160 &&
      //     !this.checkDrawer() &&
      //     item.openCartDrawer
      //   ) {
      //     this.openDrawer();

      //     if (this.checkGrid()) {
      //       this.moveGridToLeft();
      //     }
      //   }
      // },
      async function addToDrawer(item, skipOnInputEvents = false) {
        if (this.awaitingAsyncAction) {
          setTimeout(() => {
            this.addToDrawer(item);
          }, 500);
          return;
        }

        // console.log("addToDrawer: ", item);

        var itemInput = document.querySelectorAll(
          `input.quantity-detector[data-id="${item.productId}"]`
        );
        var itemsPlace = this.drawer.querySelector(".cart-drawer__cart-items"),
          newItem = this.renderTemplateData(this.item.innerHTML, item),
          itemInCart = this.drawer.querySelector(
            `.item__wrapper[data-id="${item.productId}"]`
          );
      
        if (item.productCount.length == 0) {
          item.productCount = null;
        }

        const IsQuizGridRecommendedProduct = [...itemInput].some(input => {
          const quizRecommendationCard = input.closest(".quiz-recommendations__card");
          const quizRecommendationCardsGrid = item.targetElement?.closest(".quiz-recommendations__cards");
          if (quizRecommendationCard && quizRecommendationCardsGrid) return true;
        });
      
        var isInputFieldInactiveAndZero = function (input) {
          return (
            input !== document.activeElement &&
            (input.value === "" || input.value <= 0)
          );
        };

        var isInputFieldInactive = function (input) {
          return (
            input !== document.activeElement && input.value === ""
          );
        };

        // grid item
        // itemInput = itemInput[0];
      
        // cart item
        // itemInput = itemInput[1];

        // console.log("Item input: ", itemInput);

        if (!skipOnInputEvents) {
          for (var i = 0; i < itemInput.length; i++) {
            itemInput[i].addEventListener(
              "blur",
              async function (event) {
                if (isInputFieldInactive(event.target)) {
                  // console.log("Removing from drawer - inputs");
                  item.productCount = 0;

                  this.addToDrawer(item, true);
                }
              }.bind(this)
            );
          }
        }

        // console.log(item);
      
        if (itemInCart != null) {
          if (item.productCount >= 0) {
            let currentProductQuantity = parseInt(itemInCart.querySelector(".item__image-count").innerText);
            if (isNaN(currentProductQuantity)) currentProductQuantity = 0;

            this.awaitingAsyncAction = true;
            this.showCartLoaders();
            await this.changeCartItem(
              item.productId,
              item.productCount,
              "change",
              item.ajaxQuery
            );
            this.awaitingAsyncAction = false;
            this.hideCartLoaders();

            if (item.action == "update") {
              let newProductQuantity = parseInt(item.productCount);
              if (isNaN(newProductQuantity)) newProductQuantity = 0;

              if (currentProductQuantity > newProductQuantity && item.itemAnimation) {
                this.removeImageAnimation(item.productImage);
              } else if (currentProductQuantity < newProductQuantity) {
                this.addImageAnimation(item.productImage);

                if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, currentProductQuantity);
              }
            }
      
            this.updateItemPrice(item);
            this.updateItemDrawerQty(item);
      
            if (item.productCount == 0) {
              // console.log("Removing from drawer - product count 0");
              this.removeFromDrawer(item);
            }
      
            if (item.action == "add") {
              this.addImageAnimation(item.productImage);

              if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, currentProductQuantity);
            } else if (item.action == "remove") {
              this.removeImageAnimation(item.productImage);
            }
          } else {
            if (item.type !== "modal" || isInputFieldInactiveAndZero()) {
              // console.log("Removing from drawer - model or input field inactive");
              this.removeFromDrawer(item);
              this.removeImageAnimation(item.productImage);
            }
          }
        } else if (item.productCount > 0) {
          this.awaitingAsyncAction = true;
          this.showCartLoaders();
          await this.changeCartItem(
            item.productId,
            item.productCount,
            "add",
            item.ajaxQuery
          );
          this.awaitingAsyncAction = false;
          this.hideCartLoaders();

          if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, 0);

          if (item.itemAnimation) {
            this.addImageAnimation(item.productImage);
          }
      
          itemsPlace.insertAdjacentHTML("afterbegin", newItem);
          initCartEvent(item);
        }
      
        this.updateCategories();
        this.updateSubtotalAndCartNumber();
        this.changeDrawerStatus();
        this.setInputValue(item);
      
        var addedItem = {
          productId: item.productId,
          productTitle: item.productTitle,
          productCategory: item.productCategory,
          productImage: item.productImage,
          productPrice: item.productPrice,
        };
      
        if (
          window.innerWidth > 1160 &&
          !this.checkDrawer() &&
          item.openCartDrawer
        ) {
          this.openDrawer();
      
          if (this.checkGrid()) {
            this.moveGridToLeft();
          }
        }

        function trackQuizRecommendationAddToCart(item, currentProductQuantity) {
          const productName = item.productTitle;

          const productCategory = item.productCategory;

          const newProductCount = parseInt(item.productCount);
          const newTotalProductPrice = parseInt(item.productPrice.slice(1));
          const productPrice = newTotalProductPrice / newProductCount;

          const previousProductCount = currentProductQuantity;
          const addedProductCount = newProductCount - previousProductCount;

          const totalAddedProductPrice = addedProductCount * productPrice;

          // console.log("Recommended product added to cart: ", productName);
          // console.log("productName: ", productName);
          // console.log("productPrice: ", productPrice);
          // console.log("productCategory: ", productCategory);
          // console.log("addedProductCount: ", addedProductCount);
          // console.log("totalAddedProductPrice: ", totalAddedProductPrice);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'quizRecommendedProductsAddToCart',
              qr_product_name: productName,
              qr_product_price: productPrice,
              qr_product_category: productCategory,
              qr_product_added_count: addedProductCount,
              qr_total_added_product_price: totalAddedProductPrice
          });
        }
      },      
    },
    {
      key: "removeFromDrawer",
      value: function removeFromDrawer(item) {
        // console.log(item.removedFromDrawer);
        // if (item.removedFromDrawer) return;

        // searching the item by id and removing form cart drawer
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );
        var productToZero = document.querySelector(
          '.product-card-grid-item .quantity-detector[data-id="'.concat(
            item.productId,
            '"]'
          )
        );
        if (productToZero) {
          productToZero.value = 0;
        }

        if (item.itemAnimation) {
          this.removeImageAnimation(item.productImage);
        }
        // console.log("ItemInCart: ", itemInCart);
        // console.log("Parent: ", itemInCart?.parentElement);
        if (itemInCart) {
          itemInCart?.remove(); // Remove the item from the cart
        }
      },
    },
    {
      key: "setInputValue",
      value: function setInputValue(item) {
        //itemInput with querySelectorAll -> gets both inputs of a product -> in grid and in the list view; in this way when one is changed, the another also takes this val
        var itemSelector = document.querySelector(
            'select.quantity-detector[data-id="'.concat(item.productId, '"]')
          ),
          itemInput = document.querySelectorAll(
            'input.quantity-detector[data-id="'.concat(item.productId, '"]')
          ),
          itemCount = document.querySelector(
            '.cart-drawer__cart-items .item__wrapper[data-id="'.concat(
              item.productId,
              '"] .item__image-count'
            )
          )?.innerText;
        if (typeof itemCount == "undefined") {
          itemCount = 0;
        }
        //when selected with querySelectorAll
        for (var i = 0; i < itemInput.length; i++) {
          itemInput[i].value = itemCount;
        }
        //when selected 1 element querySelector
        //itemInput.value = itemCount;

        try {
          if (itemSelector) {
            itemSelector.selectedIndex = parseInt(itemCount);
          }
        } catch (error) {
          console.error(error);
        }
      },
    },
    {
      key: "removeImageAnimation",
      value: function removeImageAnimation(image, itemHandle = null) {
        /*
      var currentElement = document.querySelector("[data-img=\"".concat(image, "\"]:not(.btn-detector)")).parentElement.parentElement;
        if(currentElement.parentElement.parentElement.classList.contains('cart-grid-view')){
        currentElement = currentElement.parentElement        
          }  
      */

        if (itemHandle != null) {
          var currentElement = $(
            '[data-handle="'.concat(itemHandle, '"]:visible:not(.btn-detector)')
          ).closest(".card-product");
        }

        var currentElement = $(
          '[data-img="'.concat(image, '"]:visible:not(.btn-detector)')
        ).closest(".card-product");

        // match the item by handle if it's not found by image and if handle is provided
        if (currentElement.length === 0 && itemHandle != null) {
          var currentElement = $(
            '[data-handle="'.concat(itemHandle, '"]:visible:not(.btn-detector)')
          ).closest(".card-product");
        }

        currentElement = currentElement.find("input.quantity-detector");
        currentElement = currentElement.get(0);

        if (!currentElement) return;

        var currentElementTop =
            window.innerWidth > 1024
              ? currentElement.getBoundingClientRect().top + 10
              : currentElement.getBoundingClientRect().top + 5,
          currentElementLeft =
            window.innerWidth > 1024
              ? currentElement.getBoundingClientRect().left + 10
              : currentElement.getBoundingClientRect().left,
          cartIcon = document.querySelector("#cartDrawer"),
          cartIconTop = cartIcon.getBoundingClientRect().top,
          // add optional
          cartIconLeft = cartIcon.getBoundingClientRect().left,
          imgElement = document.createElement("img"),
          indentificator = Math.floor(Math.random() * 100000);
        imgElement.src = image;
        imgElement.classList.add("floating-image-".concat(indentificator));
        imgElement.style.cssText = "top: 0; left: ".concat(cartIconLeft, "px;");
        document.querySelector("body").appendChild(imgElement);
        var floatingImage = document.querySelector(
          ".floating-image-".concat(indentificator)
        );
        setTimeout(function () {
          floatingImage.style.cssText = "top: "
            .concat(currentElementTop, "px; left: ")
            .concat(currentElementLeft, "px;");
        }, 1);
        setTimeout(function () {
          floatingImage.style.transform = "scale(0)";
        }, 800);
        setTimeout(function () {
          floatingImage.remove();
        }, 1000);
      },
    },
    {
      key: "addImageAnimation",
      value: function addImageAnimation(image) {
        /*
      var currentElement = document.querySelector("[data-img=\"".concat(image, "\"]:not(.btn-detector)")).parentElement.parentElement;
      if(currentElement.parentElement.parentElement.classList.contains('cart-grid-view')){
        currentElement = currentElement.parentElement        
      }
      */
        var currentElement = $(
          '[data-img="'.concat(image, '"]:visible:not(.btn-detector)')
        ).closest(".card-product");
        currentElement = currentElement.find("input.quantity-detector");
        currentElement = currentElement.get(0);

        if (!currentElement) return;

        var currentElementTop = currentElement.getBoundingClientRect().top,
          currentElementLeft = currentElement.getBoundingClientRect().left,
          cartIcon = document.querySelector("#cartDrawer"),
          cartIconTop = cartIcon.getBoundingClientRect().top,
          // add optional
          cartIconLeft = cartIcon.getBoundingClientRect().left,
          imgElement = document.createElement("img"),
          indentificator = Math.floor(Math.random() * 100000);
        imgElement.src = image;
        imgElement.classList.add("floating-image-".concat(indentificator));
        imgElement.style.cssText = "top: "
          .concat(currentElementTop, "px; left: ")
          .concat(currentElementLeft, "px;");
        document.querySelector("body").appendChild(imgElement);
        var floatingImage = document.querySelector(
          ".floating-image-".concat(indentificator)
        );
        setTimeout(function () {
          floatingImage.style.cssText = "top: 0; left: ".concat(
            cartIconLeft,
            "px;"
          );
        }, 1);
        setTimeout(function () {
          floatingImage.style.transform = "scale(0)";
        }, 800);
        setTimeout(function () {
          floatingImage.remove();
        }, 1000);
      },
    },
    {
      key: "updateCategories",
      value: function updateCategories() {
        var _this = this;

        var currentCatElement = this.drawer.querySelectorAll(".item__wrapper"),
          categoriesValue = this.drawer.querySelectorAll(".cat-value"); // resetting all values for preventing adding new values to old

        categoriesValue.forEach(function (element) {
          if (isNaN(element.innerText)) {
            element.innerText = 0;
          } else {
            element.innerText = 0; // This line doesn't change the value, consider revising it.
          }
        }); // getting each cart item, checking for an item category, adding a count of items to the category counter

        currentCatElement.forEach(function (element) {
          var elementCategory = element.dataset.category,
            categorElement = _this.drawer.querySelector(
              '.cat-value[data-cat="'.concat(elementCategory, '"]')
            ),
            elementQty = parseInt(
              element.querySelector(".item__image-count").innerText
            );

          if (!isNaN(elementQty)) {
            categorElement.innerText =
              parseInt(categorElement.innerText) + elementQty;
          }
        });
      },
    },
    {
      key: "updateItemPrice",
      value: function updateItemPrice(item) {
        // searching the item by id and changing a price
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );

        if (item.type === "modal") {
          var currentPrice =
            itemInCart.querySelector(".item__price").dataset.price;
          itemInCart.querySelector(".item__price").dataset.price =
            parseInt(currentPrice) + parseInt(item.productPriceWithoutСurrency);
          itemInCart.querySelector(".item__price").innerText = this.formatMoney(
            parseInt(currentPrice) + parseInt(item.productPriceWithoutСurrency)
          );
        } else {
          itemInCart.querySelector(".item__price").dataset.price =
            item.productPriceWithoutСurrency;
          itemInCart.querySelector(".item__price").innerText =
            item.productPrice;
        }
      },
    },
    {
      key: "updateItemDrawerQty",
      value: function updateItemDrawerQty(item) {
        // searching the item by id and changing a tag text
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );

        if (item.type === "modal") {
          var currentQty =
            itemInCart.querySelector(".item__image-count").innerText;
          itemInCart.querySelector(".item__image-count").innerText =
            parseInt(currentQty) + parseInt(item.productCount);
        } else {
          itemInCart.querySelector(".item__image-count").innerText =
            item.productCount;
        }
      },
    },
    {
      key: "updateSubtotalAndCartNumber",
      value: function updateSubtotalAndCartNumber() {
        var cartItemsCount = 0,
          cartSubtotal = 0;
        var cartItems = this.drawer.querySelectorAll(".item__wrapper"); // calculation cart items count and subtotal

        cartItems.forEach(function (element) {
          var elementQty =
            element.querySelector(".item__image-count").innerText;
          var elePricetext =
            element.querySelector(".item__price_text").innerText;
          var elePrice = elePricetext.slice(
            elePricetext.indexOf("$"),
            elePricetext.length - 2
          );
          var elementPrice = parseInt(elePrice.slice(1)) * 100;

          cartItemsCount += parseInt(elementQty);
          cartSubtotal += parseInt(elementPrice * elementQty);

          element.querySelector(".item__price").innerText =
            "$" + parseInt(elementPrice * elementQty) / 100;
        }); // searching for header bubble with cart items count and set a new value

        var cartNumber = document.querySelector("#cartDrawer .cart-number");
        cartNumber.classList.remove("hide");
        cartNumber.innerText = cartItemsCount;
        if (cartItemsCount === 0 || isNaN(cartItemsCount)) {
          cartNumber.classList.add("hide");
        } else {
          cartNumber.classList.remove("hide");
        } // searching for subtotal price value and set a new value

        // console.log(cartSubtotal);
        this.drawer.querySelector("#subtotal-value").innerText =
          this.formatMoney(cartSubtotal);
        this.drawer.querySelector("#subtotal-value-top").innerText =
          this.formatMoney(cartSubtotal);
      },
    },
    {
      key: "changeCartItem",
      value: 
      // function changeCartItem(itemId, itemQty, action) {
      //   var ajaxQuery =
      //     arguments.length > 3 && arguments[3] !== undefined
      //       ? arguments[3]
      //       : true;

      //   if (ajaxQuery) {
      //     $.ajax({
      //       type: "POST",
      //       url: "/cart/".concat(action, ".js"),
      //       data: {
      //         quantity: itemQty,
      //         id: itemId,
      //       },
      //       dataType: "json",
      //       success: function(response) {
      //         console.log("Success:", response);
      //         // Handle successful response
      //         this.updateCategories();
      //         this.updateSubtotalAndCartNumber();
      //         this.changeDrawerStatus();
      //       }.bind(this),
      //       error: function(xhr, status, error) {
      //         console.error("Error:", error);
      //         // Handle error response
      //       },
      //       complete: function(xhr, status) {
      //         console.log("Request completed");
      //         // Perform actions after completion, if needed
      //       }
      //     });
      //   }

      //   // this.updateCategories();
      //   // this.updateSubtotalAndCartNumber();
      //   // this.changeDrawerStatus();

      //   // document
      //   //   .querySelectorAll("input.quantity-detector")
      //   //   .forEach(function (element) {
      //   //     element.addEventListener("input", function () {
      //   //       var item = {
      //   //         productTitle: element.dataset.name,
      //   //         productHandle: element.dataset.handle,
      //   //         productId: element.dataset.id,
      //   //         productCount: element.value,
      //   //         productLink: element.dataset.link,
      //   //         productImage: element.dataset.img,
      //   //         productPriceWithoutСurrency:
      //   //           parseInt(element.dataset.price) * parseInt(element.value),
      //   //         productPrice: cartDrawer.formatMoney(
      //   //           parseInt(element.dataset.price) * parseInt(element.value)
      //   //         ),
      //   //         productPriceWithoutZero: cartDrawer
      //   //           .formatMoney(
      //   //             parseInt(element.dataset.price) * parseInt(element.value)
      //   //           )
      //   //           .replace(".00", ""),
      //   //         productCategory: element.dataset.category,
      //   //         type: "input",
      //   //         itemAnimation: true,
      //   //         openCartDrawer: true,
      //   //         ajaxQuery: true,
      //   //         productDataColor: element.dataset.color,
      //   //         productDataTitle: element.dataset.title,
      //   //         productDataDesc: element.dataset.desc,
      //   //       };
      //   //       cartDrawer.addToDrawer(item);
      //   //     });
      //   //   });
      // },
      function changeCartItem(itemId, itemQty, action, ajaxQuery = true) {
        let queryData;
        if (this.isMonthlySubscriptionActive) {
          queryData = { quantity: itemQty, id: itemId, selling_plan: this.SELLING_PLAN_ID };
        } else {
          queryData = { quantity: itemQty, id: itemId };
        }

        if (ajaxQuery) {
          return new Promise((resolve, reject) => {
            $.ajax({
              type: "POST",
              url: `/cart/${action}.js`,
              data: queryData,
              dataType: "json",
              success: function(response) {
                resolve(response);
              },
              error: function(xhr, status, error) {
                reject(error);
              },
            });
          });
        } else {
          this.updateCategories();
          this.updateSubtotalAndCartNumber();
          this.changeDrawerStatus();
          return Promise.resolve();
        }
      },
    },
    {
      key: "renderTemplateData",
      value: function renderTemplateData(item, replceData) {
        for (var data in replceData) {
          var length = item.includes("!{ ".concat(data, " }"));

          if (!String(replceData[data]).includes("!")) {
            do {
              item = item.replace("!{ ".concat(data, " }"), replceData[data]);
              length = item.includes("!{ ".concat(data, " }"));
            } while (length);
          }
        }

        return item;
      },
    },
    {
      key: "moveGridToLeft",
      value: function moveGridToLeft() {
        //if (window.innerWidth < 1480) {
        //this.grid.querySelectorAll('.page-width')[0].animate([{'marginLeft': '0'},{'marginLeft': '0px!important'}],500);
        //}
      },
    },
    {
      key: "moveGridToRight",
      value: function moveGridToRight() {
        this.grid
          .querySelectorAll(".page-width")[0]
          .animate({ marginLeft: "auto" }, 500);
      },
    },
    {
      key: "formatMoney",
      value: function formatMoney(cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || "${{amount}}";

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      },
    },
  ]);

  return CartDrawer;
})();

var cartDrawer = new CartDrawer(
  "#cart-drawer__wrapper",
  "#cart-item-template",
  "#shopify-section-cart-template-grid",
  ".cart-template-list",
  ".grid-select",
  ".list-select"
);
cartDrawer.updateCategories();
document.querySelector("#cartDrawer").addEventListener("click", function (e) {
  e.preventDefault();
  cartDrawer.changeDrawerStatus();
  cartDrawer.openDrawer();
});
document
  .querySelectorAll("#x-mark-drawer, #cart-drawer__overlay")
  .forEach(function (element) {
    element.addEventListener("click", function () {
      cartDrawer.closeDrawer();
    });
  });
document
  .getElementById("clear-cart-items")
  .addEventListener("click", function (e) {
    var cartIsEmpty = document.getElementById("empty-cart-drawer");

    showCartLoaders();
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      success: function success() {
        let items = gatherInfoAboutRemovingItems();

        cartDrawer.drawer
          .querySelectorAll(".item__wrapper")
          .forEach(function (element) {
            element.remove();
          });
        document
          .querySelectorAll("input.quantity-detector")
          .forEach(function (element) {
            element.value = 0;
          });
        document
          .querySelectorAll("select.quantity-detector")
          .forEach(function (element) {
            element.value = 0;
          });
        document
          .querySelectorAll('.no-spin[class^="qty-detector"]')
          .forEach(function (element) {
            element.value = 1;
          });
        
        cartDrawer.changeDrawerStatus();
        cartDrawer.updateSubtotalAndCartNumber();
        cartDrawer.closeDrawer();
        playRemoveItemsAnimations(items);
      },
      complete: function complete() {
        hideCartLoaders();
      },
      dataType: "json",
    });
  });

function gatherInfoAboutRemovingItems() {
  var cartItemsContainer = cartDrawer.drawer.querySelector(".cart-drawer__cart-items");
  var cartItems = cartItemsContainer.querySelectorAll(".item__wrapper");
  var items = [];

  cartItems.forEach(function (element) {
    var itemHandle = element.dataset.item;

    var img = element.querySelector(".item__image img");
    var ImgSrc = img.src.replace("https:", "");

    items.push({
      handle: itemHandle,
      imgSrc: ImgSrc,
    });
  });

  return items;
}

function playRemoveItemsAnimations(items) {
  items.forEach(function (item) {
    cartDrawer.removeImageAnimation(item.imgSrc, item.handle);
  });

}

window.addEventListener("DOMContentLoaded", async () => {
  /* Check if the monthly subscription is active */
  await cartDrawer.setMonthlySubscriptionState();

  /* Update the monthly subscription state over time */
  updateMonthlySubscriptionState(cartDrawer);

  /* Added | Select grid view by default */
  cartDrawer.openGrid();

  /* Change drawer status on page load */
  cartDrawer.changeDrawerStatus();
});

/* Remove unavailable products from the cart on page load */
window.addEventListener("DOMContentLoaded", () => {
  var cartItems = document.querySelectorAll(".item__wrapper");

  cartItems.forEach(function (item) {
    var itemSoldOut = item.dataset.soldOut;

    if (itemSoldOut === "true") {
      removeItemFromCart(item);
    }
  });
});

/* Open the cart drawer if the page is Cart */
window.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === "/cart" && window.innerWidth > 1280) {
    cartDrawer.openDrawer();
  }
});

if (document.querySelectorAll(".grid-select").length > 0) {
  document
    .querySelectorAll(".grid-select")[0]
    .addEventListener("click", function () {
      this.classList.add("active-button");
      cartDrawer.openGrid();
      document
        .querySelectorAll(".list-select")[0]
        .classList.remove("active-button");
    });
} //endif

if (document.querySelectorAll(".list-select").length > 0) {
  document
    .querySelectorAll(".list-select")[0]
    .addEventListener("click", function () {
      this.classList.add("active-button");
      cartDrawer.openList();
      document
        .querySelectorAll(".grid-select")[0]
        .classList.remove("active-button");
    });
} //endif

document
  .querySelectorAll("input.quantity-detector")
  .forEach(function (element) {
    element.addEventListener("input", quantityOnInput);
  });

function quantityOnInput(e) {
  e.preventDefault();

  var element = e.target;
  let onInputTimeout;

  clearTimeout(onInputTimeout);

  if (element !== undefined) {
    var item = {
      action: "update",
      targetElement: element,
      productTitle: element.dataset.name,
      productHandle: element.dataset.handle,
      productId: element.dataset.id,
      productCount: element.value,
      productLink: element.dataset.link,
      productImage: element.dataset.img,
      productPriceWithoutСurrency:
       // parseInt(element.dataset.price) * parseInt(element.value),
        parseInt(element.dataset.price),
      productPrice: cartDrawer.formatMoney(
       // parseInt(element.dataset.price) * parseInt(element.value)
        parseInt(element.dataset.price)
      ),
      productPriceWithoutZero: cartDrawer
        .formatMoney(
         // parseInt(element.dataset.price) * parseInt(element.value)
          parseInt(element.dataset.price)
        )
        .replace(".00", ""),
      productCategory: element.dataset.category,
      type: "input",
      itemAnimation: true,
      openCartDrawer: true,
      ajaxQuery: true,
      productDataColor: element.dataset.color,
      productDataTitle: element.dataset.title,
      productDataDesc: element.dataset.desc,
    };

    onInputTimeout = setTimeout(function () {
      console.log(item)
      cartDrawer.addToDrawer(item);
    }, 20);
  }
}

function quantityOnClick(e) {
  e.preventDefault();
  var clickTimeout;
  var element = e.target;
  var inputElement = element
    .closest(".input__number-holder")
    .querySelectorAll("input.quantity-detector");

  clearTimeout(clickTimeout);

  if (element.classList.contains("minus")) {
    if (inputElement[0] && inputElement[0].value >= 1) {
      inputElement[0].value && inputElement[0].value--;
    } else {
      inputElement[0].value && (inputElement[0].value = 0);
    }
  } else if (element.classList.contains("plus")) {
    inputElement[0].value && inputElement[0].value++;
  }
  //console.log('click registerd ' + inputElement[0].dataset.img);

  if (inputElement[0] !== undefined) {
    clickTimeout = setTimeout(function () {
      var item = {
        action: element.classList.contains("minus") ? "remove" : "add",
        targetElement: element,
        productTitle: inputElement[0].dataset.name,
        productHandle: inputElement[0].dataset.handle,
        productId: inputElement[0].dataset.id,
        productCount: inputElement[0].value,
        productLink: inputElement[0].dataset.link,
        productImage: inputElement[0].dataset.img,
        productPriceWithoutСurrency:
          parseInt(inputElement[0].dataset.price) * parseInt(inputElement[0].value),
        productPrice: cartDrawer.formatMoney(
          parseInt(inputElement[0].dataset.price) * parseInt(inputElement[0].value)
        ),
        productPriceWithoutZero: cartDrawer
          .formatMoney(
            parseInt(inputElement[0].dataset.price) * parseInt(inputElement[0].value)
          )
          .replace(".00", ""),
        productCategory: inputElement[0].dataset.category,
        type: "input",
        itemAnimation: true,
        openCartDrawer: true,
        ajaxQuery: true,
        productDataColor: inputElement[0].dataset.color,
        productDataTitle: inputElement[0].dataset.title,
        productDataDesc: inputElement[0].dataset.desc,
      };
      cartDrawer.addToDrawer(item);
    }, 20);
  }
}

function removeItemFromCart(itemWrapper) {
  var removingTimeout;
  var inputElement = itemWrapper.querySelectorAll("input.quantity-detector");

  clearTimeout(removingTimeout);

  if (inputElement[0] !== undefined) {
    removingTimeout = setTimeout(function () {
      var item = {
        action: "update",
        productTitle: inputElement[0].dataset.name,
        productHandle: inputElement[0].dataset.handle,
        productId: inputElement[0].dataset.id,
        productCount: 0,
        productLink: inputElement[0].dataset.link,
        productImage: inputElement[0].dataset.img,
        productPriceWithoutСurrency:
          parseInt(inputElement[0].dataset.price) * 0,
        productPrice: cartDrawer.formatMoney(
          parseInt(inputElement[0].dataset.price) * 0
        ),
        productPriceWithoutZero: cartDrawer
          .formatMoney(
            parseInt(inputElement[0].dataset.price) * 0
          )
          .replace(".00", ""),
        productCategory: inputElement[0].dataset.category,
        type: "input",
        itemAnimation: false,
        openCartDrawer: false,
        ajaxQuery: true,
        productDataColor: inputElement[0].dataset.color,
        productDataTitle: inputElement[0].dataset.title,
        productDataDesc: inputElement[0].dataset.desc,
      };
      cartDrawer.addToDrawer(item);
    }, 20);
  }
}

document.querySelectorAll(".input__number-holder").forEach(function (element) {
  var clickElement = element.querySelectorAll(".qty");

  clickElement.forEach(function (element) {
    element.addEventListener("click", quantityOnClick);
  });
});

document
  .querySelectorAll("select.quantity-detector")
  .forEach(function (element) {
    element.addEventListener("change", function () {
      var selectedOption = element.options[element.selectedIndex],
        item = {
          targetElement: element,
          productTitle: element.dataset.name,
          productHandle: element.dataset.handle,
          productId: element.dataset.id,
          productCount: selectedOption.value,
          productLink: element.dataset.link,
          productImage: element.dataset.img,
          productPriceWithoutСurrency:
            parseInt(element.dataset.price) * parseInt(selectedOption.value),
          productPrice: cartDrawer.formatMoney(
            parseInt(element.dataset.price) * parseInt(selectedOption.value)
          ),
          productPriceWithoutZero: cartDrawer
            .formatMoney(
              parseInt(element.dataset.price) * parseInt(selectedOption.value)
            )
            .replace(".00", ""),
          productCategory: element.dataset.category,
          type: "selector",
          itemAnimation: true,
          openCartDrawer: true,
          ajaxQuery: true,
          productDataColor: element.dataset.color,
          productDataTitle: element.dataset.title,
          productDataDesc: element.dataset.desc,
        };
      cartDrawer.addToDrawer(item);
    });
  });

function initCartEvent(curr_item) {
  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] input.quantity-detector'
    )
    .forEach(function (element) {
      element.addEventListener("input", function () {
        var item = {
          action: "update",
          targetElement: element,
          productTitle: element.dataset.name,
          productHandle: element.dataset.handle,
          productId: element.dataset.id,
          productCount: element.value,
          productLink: element.dataset.link,
          productImage: element.dataset.img,
          productPriceWithoutСurrency:
            parseInt(element.dataset.price) * parseInt(element.value),
          productPrice: cartDrawer.formatMoney(
            parseInt(element.dataset.price) * parseInt(element.value)
          ),
          productPriceWithoutZero: cartDrawer
            .formatMoney(
              parseInt(element.dataset.price) * parseInt(element.value)
            )
            .replace(".00", ""),
          productCategory: element.dataset.category,
          type: "input",
          itemAnimation: true,
          openCartDrawer: true,
          ajaxQuery: true,
          productDataColor: element.dataset.color,
          productDataTitle: element.dataset.title,
          productDataDesc: element.dataset.desc,
        };
        cartDrawer.addToDrawer(item);
      });
    });

  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] .input__number-holder'
    )
    .forEach(function (element) {
      var clickTimeout;
      var clickElement = element.querySelectorAll(".qty");
      var inputElement = element.querySelectorAll("input.quantity-detector");

      clickElement.forEach(function (element) {
        element.addEventListener("click", function (e) {
          e.preventDefault();

          clearTimeout(clickTimeout);

          if (element.classList.contains("minus")) {
            if (inputElement[0] && inputElement[0].value >= 1) {
              inputElement[0].value && inputElement[0].value--;
            } else {
              inputElement[0].value && (inputElement[0].value = 0);
            }
          } else if (element.classList.contains("plus")) {
            inputElement[0].value && inputElement[0].value++;
          }
          //console.log('click registerd ' + inputElement[0].dataset.img);

          if (inputElement[0] !== undefined) {
            clickTimeout = setTimeout(function () {
              var item = {
                targetElement: e.target,
                action: element.classList.contains("minus") ? "remove" : "add",
                productTitle: inputElement[0].dataset.name,
                productHandle: inputElement[0].dataset.handle,
                productId: inputElement[0].dataset.id,
                productCount: inputElement[0].value,
                productLink: inputElement[0].dataset.link,
                productImage: inputElement[0].dataset.img,
                productPriceWithoutСurrency:
                  parseInt(inputElement[0].dataset.price) *
                  parseInt(inputElement[0].value),
                productPrice: cartDrawer.formatMoney(
                  parseInt(inputElement[0].dataset.price) *
                    parseInt(inputElement[0].value)
                ),
                productPriceWithoutZero: cartDrawer
                  .formatMoney(
                    parseInt(inputElement[0].dataset.price) *
                      parseInt(inputElement[0].value)
                  )
                  .replace(".00", ""),
                productCategory: inputElement[0].dataset.category,
                type: "input",
                itemAnimation: true,
                openCartDrawer: true,
                ajaxQuery: true,
                productDataColor: inputElement[0].dataset.color,
                productDataTitle: inputElement[0].dataset.title,
                productDataDesc: inputElement[0].dataset.desc,
              };
              cartDrawer.addToDrawer(item);
            }, 20);
          }
        });
      });
    });

  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] select.quantity-detector'
    )
    .forEach(function (element) {
      element.addEventListener("change", function () {
        var selectedOption = element.options[element.selectedIndex],
          item = {
            targetElement: element,
            productTitle: element.dataset.name,
            productHandle: element.dataset.handle,
            productId: element.dataset.id,
            productCount: selectedOption.value,
            productLink: element.dataset.link,
            productImage: element.dataset.img,
            productPriceWithoutСurrency:
              parseInt(element.dataset.price) * parseInt(selectedOption.value),
            productPrice: cartDrawer.formatMoney(
              parseInt(element.dataset.price) * parseInt(selectedOption.value)
            ),
            productPriceWithoutZero: cartDrawer
              .formatMoney(
                parseInt(element.dataset.price) * parseInt(selectedOption.value)
              )
              .replace(".00", ""),
            productCategory: element.dataset.category,
            type: "selector",
            itemAnimation: true,
            openCartDrawer: true,
            ajaxQuery: true,
            productDataColor: element.dataset.color,
            productDataTitle: element.dataset.title,
            productDataDesc: element.dataset.desc,
          };
        cartDrawer.addToDrawer(item);
      });
    });

  // document.querySelectorAll('.item__wrapper[data-id="'+curr_item.productId+'"] #clear-cart-item').forEach(itemRemoveElement => {
  //   if(itemRemoveElement) {
  //     itemRemoveElement.addEventListener('click', function(e) {
  //       e.preventDefault();
  //       const item = e.target.closest('.item__wrapper');
  //       const qtyPicker = item.querySelector('input.quantity-detector');
  //       if(qtyPicker) {
  //         qtyPicker.value = 0;
  //         qtyPicker.dispatchEvent(new Event('input'));
  //       }
  //     });
  //   }
  // });
}

document.querySelectorAll("#clear-cart-item").forEach((itemRemoveElement) => {
  if (itemRemoveElement) {
    itemRemoveElement.addEventListener("click", function (e) {
      e.preventDefault();
      const item = e.target.closest(".item__wrapper");
      const qtyPicker = item.querySelector("input.quantity-detector");
      if (qtyPicker) {
        qtyPicker.value = 0;
        qtyPicker.dispatchEvent(new Event("input"));
      }
    });
  }
});

// function clear_cart_item(ele) {
//   const item = ele.closest('.item__wrapper');
//   const qtyPicker = item.querySelector('input.quantity-detector');
//   if(qtyPicker) {
//     qtyPicker.value = 0;
//     qtyPicker.dispatchEvent(new Event('input'));
//   }
// }
function clear_cart_item(ele) {
  const item = ele.closest(".item__wrapper");
  const qtyPicker = item.querySelector("input.quantity-detector");
  if (qtyPicker) {
    qtyPicker.value = 0;
    qtyPicker.dispatchEvent(new Event("input"));
  }
  // if (item) {
  //   item.remove();
  //   this.removeImageAnimation(item.productImage);
  // }
  cartDrawer.updateCategories();
  cartDrawer.updateSubtotalAndCartNumber();
  cartDrawer.changeDrawerStatus();
}

function updateMonthlySubscriptionState(cartDrawer) {
  const subscriptionCheckboxes = document.querySelectorAll(".make-monthly-order-checkbox");

  subscriptionCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      cartDrawer.isMonthlySubscriptionActive = !cartDrawer.isMonthlySubscriptionActive;
    });
  });
}

async function allItemsAreMonthly() {
  const cartResponse = await fetch('/cart.js');
  const cartData = await cartResponse.json();

  if (cartData.items.length === 0) {
    return false;
  }
  
  return cartData.items.every(item => item.selling_plan_allocation != null);
}